import { getSignificantDigitCount } from '../../../../../../utils/forms/inputs/getSignificantDigitCount';
import { MAX_SAFE_SIGNIFICANT_DIGITS } from '../../../../../../constants';

export const shouldFormatFloatValue = (value: string) =>
  getSignificantDigitCount(value) <= MAX_SAFE_SIGNIFICANT_DIGITS;
